import React, { FC }  from "react";
import { useHistory } from "react-router";
import { Button }     from "semantic-ui-react";

const ReservationCancelRequestTransitionButton: FC = () => {
  const history = useHistory();
  return (
    <>
      <Button
        onClick={ () => history.push("/reservation/cancel/requests") }
      >
        予約キャンセル依頼を確認する
      </Button>
    </>
  );
}

export default ReservationCancelRequestTransitionButton;
